// Module
var code = "<path fill-rule=\"evenodd\" d=\"M89.47 17.29L34.078 72.44 9.535 48.01a4.414 4.414 0 0 0-6.239 0 4.372 4.372 0 0 0 0 6.214l27.662 27.545a4.42 4.42 0 0 0 3.12 1.29c1.17 0 2.29-.463 3.11-1.29l58.523-58.266a4.387 4.387 0 0 0 0-6.212 4.417 4.417 0 0 0-6.24 0z\"></path> ";
// Exports
export default code;